<template lang="pug">
  include ../../../pug/mixins/bem
  +b.info-modal.FORM(@submit.prevent='send',
                    :class='classes')
    +b.form-load(v-if='load')                
      loading
    +e.title.P {{ _("Получи полную инструкцию на почту") }}
    +e.text.P(
      v-if='showText && !isAuth'
    ) {{ _("Мы подготовили для Вас инструкцию, которую Вы можете удобно получить на email. Для того чтоб получить инструкцию заполните поле email и после этого нажмите кнопку 'Получить' ") }}
    +e.text.P(
      v-if='showText && isAuth'
    ) {{ _("Мы подготовили для Вас инструкцию, которую Вы можете удобно получить на email. Для того чтоб получить инструкцию нажмите кнопку 'Получить' ") }}
    slot(name='form')
      input-group(type="text"
                  id='email'
                  name='email'
                  v-if='!isAuth'
                  :placeholder='_("Введите адрес электронной почты")'
                  v-validate="'required|min:2|max:50|email'"
                  v-model="email")
    slot(
      name='submit'
    )            
      +e.btn.BUTTON.default-btn(type='submit') {{ _("Получить") }}      
    +b.close-popup--is-white(
      @click='$emit("close")',
      v-if='!showText'
    ) &times;      
</template>
<script>
import InputGroup from "./InputGroup"
import getInfoMixin from './getInfoMixin'
export default {
  name: "GetInfo",
  mixins: [ getInfoMixin ],
  props: {
    classes: {},
    showText: {},
    
  },
  components: {
    InputGroup
  },
  data() {
    return {
      email: '',
      load: false,
      isAuth: window.authent
    }
  },
  
}
</script>



// WEBPACK FOOTER //
// src/js/shared/components/GetInfo.vue